import { render, staticRenderFns } from "./PayratePlandayChanges.vue?vue&type=template&id=b78d66da&"
import script from "./PayratePlandayChanges.vue?vue&type=script&lang=js&"
export * from "./PayratePlandayChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports